export default __webpack_public_path__ + "static/media/mobile-app.5a60ace4.png";